import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import * as api from "./adminApi";
import {
  AdminShell,
  Card,
  Field,
  InlineForm,
  Row,
  StatusBadge,
  Text,
  useAsync,
} from "./components";

export function ProgrammesPage() {
  const nav = useNavigate();
  const { data, error, reload } = useAsync(api.listProgrammes, []);
  const [title, setTitle] = useState("");

  return (
    <AdminShell crumbs={[{ label: "Admin" }]} title="Programmes">
      {error && <Card>{error}</Card>}
      <Card>
        {data?.length === 0 && <p style={{ color: "#666" }}>No programmes yet.</p>}
        {data?.map((p) => (
          <Row key={p.id}>
            <Link to={`/admin/programmes/${p.id}`}>{p.title}</Link>
            <span style={{ display: "flex", gap: "0.6rem", alignItems: "center" }}>
              <span style={{ color: "#888", fontSize: "0.8rem" }}>{p._count.tracks} tracks</span>
              <StatusBadge status={p.status} />
            </span>
          </Row>
        ))}
      </Card>

      <Card>
        <strong>New programme</strong>
        <div style={{ marginTop: "0.6rem" }}>
          <InlineForm
            submitLabel="Create"
            onSubmit={async () => {
              const { id } = await api.createProgramme({ title });
              setTitle("");
              reload();
              nav(`/admin/programmes/${id}`);
            }}
          >
            <Field label="Title">
              <Text value={title} onChange={(e) => setTitle(e.target.value)} required />
            </Field>
          </InlineForm>
        </div>
      </Card>

      <p style={{ marginTop: "1.5rem" }}>
        <Link to="/admin/learners">Learners &amp; assignments →</Link>
        {" · "}
        <Link to="/admin/certificates">Certificate templates →</Link>
        {" · "}
        <Link to="/admin/feedback-templates">Feedback templates →</Link>
        {" · "}
        <Link to="/admin/reports">Progress report →</Link>
        {" · "}
        <Link to="/admin/notifications">Notification issues →</Link>
      </p>
    </AdminShell>
  );
}
